<template>
  <div id="informatioan_detail">
    <TabBar />
    <div class="container">
      <div class="news_item">
        <div class="new_img">
          <img src="../assets/images/news_1.png" alt />
        </div>
        <div class="new_txt">
          <span>2020.01.01</span>
          <h3>阿里云打造“云钉一体”：为数字经济时代构建基础设施</h3>
          <p>因为疫情的关系，原本计划在线下举办的2020阿里云峰会，最终改在了线上举行。</p>
          <p>不过就疫情对企业办公乃至整个人类社会的影响而言，这只不过是冰山一角。</p>
          <h5>疫情加速了数字化转型进程</h5>
          <p>通过这次席卷全球的疫情，越来越多的政府、企业、学校甚至民众，都深刻感受到了数字化给工作和生活带来的巨大改变。一方面，线上会议、远程办公、在线教育、电子商务……各种无接触经济得到了前所未有的重视和发展；另一方面，众多企业亲眼目睹了数字化办公在疫情期间带来的巨大便利，其迫切想要开展数字化转型的愿望也变得空前强烈。</p>
          <p>在阿里云智能总裁张建锋看来，就企业的数字化转型进程而言，这次疫情让不少政府和企业都充分认识到了数字化的迫切性和重要性，从而使得其对数字化转型的需求也已因此加速。原本需要三到五年的时间才能完成的数字化发展历程，有可能会在一年之内就能加速转换。</p>
          <p>“对于数字化要不要做、或者数字经济是不是未来这个话题，目前全社会都已经达到了高度共识。”张建锋表示，“如今我们关注的重点，是快速实现数字化的方式。通过这些方式，让各个行业能够根据数字化重构自己的技术体系、业务体系、商业模式，这才是目前最关键的事情。”</p>
        </div>
        <div class="news_item">
          <div class="new_img">
            <img src="../assets/images/news_2.png" alt />
          </div>
          <div class="new_txt">
            <h5>“云钉一体”的新型操作系统</h5>
            <p>从过去的信息时代到如今的数据时代，信息系统也面临着全新的升级换代。必须要有一个新型的操作系统，才能让程序员即便是面对大数据、人工智能、物联网、移动化……也可以游刃有余地为不同行业进行系统开发。</p>
            <p>在阿里云看来，中台就是这样的一个新型操作系统，而钉钉则可以成为这个操作系统的核心。</p>
            <p>也正是这样的认识，才让阿里云在本届峰会上宣布了一个重要决定：将钉钉与阿里云进行深度融合，实现“云钉一体”的新型操作系统。 顾名思义，“云钉一体”就是将阿里云和钉钉融为一个整体，阿里云提供水电煤一样的算力基础设施，钉钉则像Windows操作系统那样，让企业可以快速开发管理组织和业务的应用。</p>
            <p>张建锋指出，虽然在很多人眼里，钉钉只是一个沟通工具，但其实钉钉能够做到的事情早已远远超越了沟通的范畴。“光是浙江就有100多万政府工作人员在钉钉上办公，有1000多个应用是基于钉钉平台开发的，这就是操作系统的典型特征——自己做一部分事情，还可以让大家在上面做更多的事情。”</p>
            <p>“以前在传统信息时代，大家对于PC＋Windows的组合都非常熟悉。如今计算机的体系结构变了，操作系统也随之改变。企业既需要云这样的新型计算架构，也需要钉钉这样的新型操作系统，所以才会有像阿里云＋钉钉这样‘云钉一体’的组合出现。”张建锋表示。</p>
            <p>钉钉CEO陈航透露的一组数字，则进一步印证了张建锋的观点：截至目前为止，钉钉用户数量已经突破3亿，企业组织数突破1500万家。来自各行各业的企业已经基于“云钉一体”的基础设施，开发了数十万种企业应用。如今已有超过20万企业应用开发者，在钉钉开发平台上帮助企业定制属于自己的应用。</p>

            <h5>做深基础，做厚中台，做强生态</h5>
            <p>在2020阿里云峰会上，张建锋首次对外展示了阿里云再生长的三大方向：</p>
            <p>一、做深基础：把云的底座做深，除了飞天云操作系统之外，阿里云还将基于云的特点，加大在芯片、服务器、数据库、路由器、交换机等领域的自研力度，以此构建数字经济时代的整套基础设施。</p>
            <p>一、做深基础：把云的底座做深，除了飞天云操作系统之外，阿里云还将基于云的特点，加大在芯片、服务器、数据库、路由器、交换机等领域的自研力度，以此构建数字经济时代的整套基础设施。</p>
            <p>三、做强生态：基于云和新型操作系统，做大做强一个繁荣的应用服务生态。</p>
            <p>“之前阿里云曾经公布过3年投资2000亿的计划，不过对于数字经济基础设施来说，2000亿的投资规模其实并不算大，未来3年可能还会投入更多，并且还将大量引进云服务器、网络、芯片、数据库、人工智能等核心技术领域的科技人才。”张建锋透露，“最终并不是阿里云来做所有的这些事情，我们是一个开放的体系，希望能够基于云的结构和新型的操作系统，帮助各行各业进行软件应用的开发，所以我们提出了做深基础、做厚中台、做强生态，这是我们作为数字经济时代基础设施的一个主要出发点，也是一个落脚点。”</p>
          </div>
        </div>
      </div>
    </div>
    <div class="line"></div>
    <div class="container">
      <div class="read">推荐阅读</div>
      <ul class="recommend_new">
        <li class="new_item">
          <img src="../assets/images/info_6.png" alt />
          <p>2020.01.01</p>
          <h3>
            IBM将不再开发人脸识别技术，已向
            国会致函
          </h3>
        </li>
        <li class="new_item">
          <img src="../assets/images/info_7.png" alt />
          <p>2020.01.01</p>
          <h3>
            瑞萨电子升级ZMOD4410室内空气
            质量监控平台
          </h3>
        </li>
        <li class="new_item">
          <img src="../assets/images/news_3.png" alt />
          <p>2020.01.01</p>
          <h3>
            知行科技：本土Tier 1正迈向量产新
            阶段！
          </h3>
        </li>
      </ul>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.container {
  width: 1000px;
  margin: 0 auto;
  .new_txt {
    span {
      display: block;
      margin: 40px 0 20px 0;
      font-size: 16px;
      line-height: 26px;
    }
    p {
      text-indent: 2em;
      font-size: 16px;
      line-height: 32px;

      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 7;
      -webkit-box-orient: vertical;
    }
    h3 {
      font-size: 32px;
      margin-bottom: 20px;
      line-height: 42px;
    }
    h5 {
      font-size: 18px;
      line-height: 32px;
      margin: 20px 0;
    }
  }
  .read {
    text-align: center;
  }
  .recommend_new {
    display: flex;
    justify-content: space-between;
    margin: 40px 0 50px 0;
    .new_item {
      width: 320px;
      p {
        margin: 16px 0;
        font-size: 14px;
        line-height: 24px;
      }
      h3 {
        font-size: 20px;
        line-height: 30px;
      }
    }
  }
}
.line {
  height: 10px;
  background: rgba(245, 245, 245, 1);
  margin: 40px 0;
}
</style>